module.exports = __webpack_public_path__ + "img/kyc.9357a7ed.png";